// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3oDnY","additionalInfo":"AgreementModal_additionalInfo__Y-Fmv"};